import http from "@/http-common";

// import http_multipart from "@/http-multipart";

/**
 *
 */
class RevenueManagementService {
    /**
     * Danh sách khoản
     */
    findAllRevenueManagement(usingStatus, name, category, limit, page) {
        return http.get("/fn/fees/revenue-management/search", {params: {usingStatus, name, category, limit, page}});
    }

    /**
     * Tạo mới khoản
     */
    createRevenueManagement(data) {
        return http.post("/fn/fees/revenue-management/create", data);
    }

    /**
     * Cập nhật khoản mới khoản
     */
    updateRevenueManagement(data) {
        return http.post("/fn/fees/revenue-management/update", data);
    }

    /**
     * Xóa khoản
     */
    deleteRevenueManagement(id) {
        return http.delete(`/fn/fees/revenue-management/delete/${id}`);
    }

    /**
     * Số lượng khoản đang áp dụng cho lớp
     */
    findClassRevenueManagement(className) {
        return http.get(`/fn/fees/revenue-management/class/info?className=${className}`);
    }

    /**
     * Số lượng khoản đang áp dụng cho nhóm
     */
    findGroupRevenueManagement(groupName) {
        return http.get(`/fn/fees/revenue-management/group/info?groupName=${groupName}`);
    }

    /**
     * Danh sách khoản áp dụng cho lớp
     */
    getRevenueManagementInClass(idClass) {
        return http.get(`/fn/fees/revenue-management/class/revenue-management-in-class?idClass=${idClass}`);
    }

    /**
     * Danh sách khoản áp dụng cho nhóm
     */
    getRevenueManagementInGroup(idGroup) {
        return http.get(`/fn/fees/revenue-management/group/revenue-management-in-group?idGroup=${idGroup}`);
    }

    /**
     * Thêm khoản cho lớp
     */
    addRevenueForClass(data) {
        return http.post("/fn/fees/revenue-management/class/add-in-class", data);
    }

    /**
     * Thêm khoản cho nhóm
     */
    addRevenueForGroup(data) {
        return http.post("/fn/fees/revenue-management/group/add-in-group", data);
    }

    /**
     * Thông tin chi tiết khoản của học sinh theo lớp
     */
    searchStudentRevenueForClass(status, fullName, idClass, idGroup) {
        return http.get("/fn/fees/revenue-management/student/detail/info-in-class", {
            params: {
                status,
                fullName,
                idClass,
                idGroup
            }
        });
    }
    searchStudentRevenueForGroup(status, fullName, idClass, idGroup) {
        return http.get("/fn/fees/revenue-management/student/detail/info-in-group", {
            params: {
                status,
                fullName,
                idClass,
                idGroup
            }
        });
    }

    /**
     * Thay đổi trạng thái sử dụng khoản thu cho từng học sinh
     */
    studentRevenueChangeActive(idKid, revenueManagementId, type, active, idClass, idGroup) {
        return http.get("/fn/fees/revenue-management/student/change-active", {
            params: {
                idKid,
                revenueManagementId,
                type,
                active,
                idClass, idGroup
            }
        });
    }

    /**
     * Xóa  khoản cho từng học sinh
     */
    deleteStudentManagement(idKid, revenueManagementId, type, idClass, idGroup) {
        return http.delete("/fn/fees/revenue-management/student/delete-one", {
            params: {
                idKid,
                revenueManagementId,
                type,
                idClass,
                idGroup
            }
        });
    }

    /**
     * Thông tin chi tiết khoản đăng ký của học sinh theo lớp
     */
    searchKidsPackageInClass(status, fullName, idClass, idGroup) {
        return http.get("/fn/fees/revenue-management/student/detail-register/info-in-class", {
            params: {
                status,
                fullName,
                idClass,
                idGroup
            }
        });
    }
    /**
     * Thông tin chi tiết khoản đăng ký của học sinh theo lớp
     */
    searchKidsPackageInGroup(status, fullName, idClass, idGroup) {
        return http.get("/fn/fees/revenue-management/student/detail-register/info-in-group", {
            params: {
                status,
                fullName,
                idClass,
                idGroup
            }
        });
    }

    /**
     * Kích hoạt/hủy kích hoạt khoản cho một học sinh
     */
    activeKidsPackageOne(data) {
        return http.post("/fn/fees/revenue-management/student/active-one", data);
    }

    /**
     * Kích hoạt/hủy kích hoạt khoản cho nhiều học sinh
     */
    activeKidsPackageMany(data) {
        return http.post("/fn/fees/revenue-management/student/active-many", data);
    }

    /**
     * Lấy danh sách khoản thu không thuộc lớp
     */
    findAllRevenueManagementNoClass(id) {
        return http.get(`/fn/fees/revenue-management/search/no-class/${id}`);
    }
    /**
     * Lấy danh sách khoản thu không thuộc nhóm
     */
    findAllRevenueManagementNoGroup(id) {
        return http.get(`/fn/fees/revenue-management/search/no-group/${id}`);
    }


    /**
     * Thêm khoản cho 1 học sinh
     */
    addRevenueManagementOneStudent(data) {
        return http.post(`/fn/fees/revenue-management/student/add-revenue-one`, data);
    }

    /**
     * Lấy danh sách thông tin học sinh và các khoản đã được tính toán trên web cho lớp
     */
    getFilterAll(month, kidStatus, idGrade, idClass, name, collectionTurn, createdYear, page, limit) {
        return http.get(`/fn/fees/revenue-management/search/filter-all`,
            {params: {month, kidStatus, idGrade, idClass, name, collectionTurn, createdYear, page, limit}});
    }
    /**
     * Lấy danh sách thông tin học sinh và các khoản đã được tính toán trên web cho nhóm
     */
    getFilterAllForGroup(month, kidStatus, idGrade, idClass, idGroup, name, collectionTurn, createdYear, page, limit) {
        return http.get(`/fn/fees/revenue-management/search/filter-all/group`,
            {params: {month, kidStatus, idGrade, idClass, idGroup, name, collectionTurn, createdYear, page, limit}});
    }
    /**
     * Khởi tạo data cho lớp
     */
    initializeDataRevenueManagement(data) {
        return http.post(`/fn/fees/revenue-management/initialize-data`, data);
    }
    /**
     * Khởi tạo data cho nhóm
     */
    initializeDataRevenueManagementForGroup(data) {
        return http.post(`/fn/fees/revenue-management/initialize-data/group`, data);
    }
    /**
     * Lấy danh sách khoản đăng ký cho học sinh dùng để khởi cho lớp
     */
    findAllRevenueManagementStudent(data) {
        return http.post(`/fn/fees/revenue-management/search/list-revenue`, data);
    }

    /**
     * Lấy danh sách khoản đăng ký cho học sinh dùng để khởi tạo cho nhóm
     */
    findAllRevenueManagementStudentForGroup(data) {
        return http.post(`/fn/fees/revenue-management/search/list-revenue/group`, data);
    }

    /**
     * Xem chi tiết khoản thu (số lượng, đơn giá, giảm giá)
     */
    showDetailPayment(orderKidCode, collectionTurn, nameKt, type, year) {
        return http.get(`/fn/fees/revenue-management/show-detail-payment`, {params: {orderKidCode, collectionTurn, nameKt, type, year}});
    }
    /**
     * Cập nhật tiển của khoản
     */
    updateDetailPayment(data) {
        return http.post(`/fn/fees/revenue-management/update-detail-payment`, data);
    }

    /**
     * Hiển thị thông tin tiền đã thu
     */
    showCollectedMoney(id) {
        return http.get(`/fn/fees/revenue-management/show-collected-money/${id}`);
    }

    /**
     * Cập nhật tiển đã thu
     */
    updateCollectedMoney(data) {
        return http.post(`/fn/fees/revenue-management/update-collected-money`, data);
    }

    /**
     * Khởi tạo khoản thu thực tế theo lớp
     */
    initializeOrderKidsExcelNew(data) {
        return http.post(`/fn/fees/revenue-management/initialize-order-kids-excel`, data);
    }

    /**
     * Khởi tạo khoản thu thực tế theo nhóm
     */
    initializeOrderKidsExcelNewForGroup(data) {
        return http.post(`/fn/fees/revenue-management/initialize-order-kids-excel/group`, data);
    }

    /**
     lấy danh sách nhóm
     *
     */
    getListKidsGroup() {
        return http.get('/fn/fees/listNameKidsGroup')
    }
}


export default new RevenueManagementService();
